import React from 'react';
import PropTypes from 'prop-types';

const ChestOfDrawers = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.7}
      d="M20 14.67H4m0-5.4h16m-8.889 8.1h1.778m-1.778-5.4h1.778m-1.778-5.4h1.778m4 13.5v1.8m-9.778-1.8v1.8M20 4.41v15.12a.546.546 0 0 1-.33.499.528.528 0 0 1-.203.041H4.533a.528.528 0 0 1-.492-.333A.545.545 0 0 1 4 19.53V4.41c0-.143.056-.28.156-.382a.53.53 0 0 1 .377-.158h14.934a.53.53 0 0 1 .377.158c.1.101.156.239.156.382Z"
    />
    <path
      fill={color}
      d="M3.063 3.25A.2.2 0 0 1 3.257 3H20.74a.2.2 0 0 1 .193.251l-.213.8a.2.2 0 0 1-.193.149H3.46a.2.2 0 0 1-.194-.15l-.204-.8Z"
    />
  </svg>
);

ChestOfDrawers.propTypes = {
  color: PropTypes.string
};

export default ChestOfDrawers;
